import {
  ExperimentNames,
  isEventDetailsPageHiddenInternal,
  isEventRsvpButtonVisible,
  isExternal,
} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {MouseEventHandler} from 'react'
import {useWidgetActions, useWidgetState} from '../../hooks/state-provider'
import {getEventDetailsPageUrl, getEventUrl, isEventRestricted} from '../../selectors/events'
import {LinkToPageProps} from './interface'
import s from './link-to-page.scss'

export const LinkToPage = ({
  dataHook,
  style,
  className,
  children,
  focusable = true,
  dataAnchor,
  baseUrl,
  pageUrl,
  queryParams,
  hasAdditionalInfoToggle,
  event,
  allowExternal,
}: LinkToPageProps) => {
  const {experiments} = useExperiments()
  const state = useWidgetState(st => st)
  const actions = useWidgetActions()

  const newDetailsPageVisibilityNavigationEnabled = experiments.enabled(
    ExperimentNames.NewDetailsPageVisibilityNavigation,
  )
  const isRestricted = isEventRestricted(state, event, newDetailsPageVisibilityNavigationEnabled)
  const url = allowExternal
    ? getEventUrl(state, event, baseUrl, pageUrl?.relativeUrl, queryParams, newDetailsPageVisibilityNavigationEnabled)
    : getEventDetailsPageUrl(
        state,
        event,
        baseUrl,
        pageUrl?.relativeUrl,
        queryParams,
        newDetailsPageVisibilityNavigationEnabled,
      )
  const disabled = (hasAdditionalInfoToggle && !url) || !isEventRsvpButtonVisible(event)
  const isExternalUrl = allowExternal && isExternal(event) && isEventDetailsPageHiddenInternal(event)

  let onClick: MouseEventHandler
  if (hasAdditionalInfoToggle) {
    onClick = e => e.preventDefault()
  } else if (url) {
    onClick = _e => actions.onLinkNavigatedToPage(event)
  } else {
    onClick = e => {
      if (isRestricted) {
        e.stopPropagation()
      }
      actions.navigateToPage(event)
    }
  }

  if (disabled) {
    return <div className={className}>{children}</div>
  }

  return (
    <a
      tabIndex={focusable ? 0 : -1}
      data-hook={dataHook}
      style={style}
      className={classNames(s.root, className)}
      href={url}
      target={isExternalUrl ? '_blank' : undefined}
      rel={isExternalUrl ? 'nofollow' : ''}
      onClick={onClick}
      data-anchor={dataAnchor}
    >
      {children}
    </a>
  )
}
